module.exports = __webpack_public_path__ + "a9d5e82fe30e1da6f4e21f3488b9d518.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/channels/channel_1.png
// module id = 152
// module chunks = 7